import React from "react";

export default function FeatureList({ features }) {
    return (
      <div className="flex flex-col gap-1">
        {features?.map((feature, index) => (
          <div key={index}>
            <span className="baseText !font-medium  max-w-xs me-1">
              {feature?.title}
            </span>
            <span className="baseText text-navLink">{feature?.description}</span>
          </div>
        ))}
      </div>
    );
  }